import store from '../store';

function showErrorMessage(error, allowRefresh, allowClose) {
   let message = error.message;

   if (error.response && error.response.data) {
      message = error.response.data;
   }

   store.dispatch("setSystemError", {
      message: message,
      allowRefresh: allowRefresh,
      allowClose: allowClose,
   });
   store.dispatch("loading", false);
}

function showMessage(message, allowRefresh, allowClose) {
   store.dispatch("setSystemError", {
      message: message,
      allowRefresh: allowRefresh,
      allowClose: allowClose,
   });

   store.dispatch("loading", false);

}

export default {
   showErrorMessage,
   showMessage,
};